// @flow strict
import styled from "styled-components";

const MobileOnly = styled.div.attrs({ className: "hidden-md hidden-lg" })``;

export default MobileOnly;
